import { takeLatest } from "redux-saga/effects";
import { POST_CREATE_PRODUCT_REQUEST } from "../consts";
import { postCreateProductRequestSaga } from "./saga";

export default function* watchCreateProduct() {
  yield takeLatest(POST_CREATE_PRODUCT_REQUEST, postCreateProductRequestSaga);
}
